/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SchedulerCrewResponse } from '../../models/scheduler-crew-response';
import { UpdateSchedulerCrewStatusRequest } from '../../models/update-scheduler-crew-status-request';

export interface UpdateSchedulerCrewStatus$Params {
  id: number;
      body: UpdateSchedulerCrewStatusRequest
}

export function updateSchedulerCrewStatus(http: HttpClient, rootUrl: string, params: UpdateSchedulerCrewStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<SchedulerCrewResponse>> {
  const rb = new RequestBuilder(rootUrl, updateSchedulerCrewStatus.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SchedulerCrewResponse>;
    })
  );
}

updateSchedulerCrewStatus.PATH = '/api/scheduler/crew/{id}/status';
